// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/TCCC-UnityText-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/TCCC-UnityText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/TCCC-UnityText-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/TCCC-UnityText-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/TCCC-UnityHeadline-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/TCCC-UnityHeadline-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/TCCC-UnityHeadline-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/TCCC-UnityHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-weight: 300;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
    font-weight: 400;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}


@font-face {
    font-weight: 500;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
    font-weight: 600;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
    font-weight: 700;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
    font-weight: 800;
    font-family: TCCC-UnityText;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}

@font-face {
    font-weight: 400;
    font-family: TCCC-UnityHeadline;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}

@font-face {
    font-weight: 500;
    font-family: TCCC-UnityHeadline;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

@font-face {
    font-weight: 600;
    font-family: TCCC-UnityHeadline;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}

@font-face {
    font-weight: 700;
    font-family: TCCC-UnityHeadline;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}

@font-face {
    font-weight: 800;
    font-family: TCCC-UnityHeadline;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
}








`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAA+D;AACnE;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAAiE;AACrE;;;AAGA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAAiE;AACrE;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAAgE;AACpE;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAAgE;AACpE;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4DAA8D;AAClE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAAmE;AACvE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAAqE;AACzE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAAoE;AACxE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAAoE;AACxE;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAAkE;AACtE","sourcesContent":["@font-face {\n    font-weight: 300;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Light.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 400;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Regular.woff2') format('woff2');\n}\n\n\n@font-face {\n    font-weight: 500;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Regular.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 600;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Medium.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 700;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Medium.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 800;\n    font-family: TCCC-UnityText;\n    src: url('../fonts/TCCC-UnityText-Bold.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 400;\n    font-family: TCCC-UnityHeadline;\n    src: url('../fonts/TCCC-UnityHeadline-Light.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 500;\n    font-family: TCCC-UnityHeadline;\n    src: url('../fonts/TCCC-UnityHeadline-Regular.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 600;\n    font-family: TCCC-UnityHeadline;\n    src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 700;\n    font-family: TCCC-UnityHeadline;\n    src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n\n@font-face {\n    font-weight: 800;\n    font-family: TCCC-UnityHeadline;\n    src: url('../fonts/TCCC-UnityHeadline-Bold.woff2') format('woff2');\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
